import Vue from 'vue'
import AtlasIcon from '@/components/ui/AtlasIcon'
import AtlasCity from '@/components/ui/AtlasName/AtlasCity'
import AtlasCountry from '@/components/ui/AtlasName/AtlasCountry'
import AtlasFlag from '@/components/ui/AtlasName/AtlasFlag'
import ChartLine from '@/components/ui/Charts/ChartLine'

Vue.component('AtlasIcon', AtlasIcon)
Vue.component('AtlasCity', AtlasCity)
Vue.component('AtlasCountry', AtlasCountry)
Vue.component('AtlasFlag', AtlasFlag)
Vue.component('ChartLine', ChartLine)
